export enum CRONE_JOB_STATUS {
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  PAUSED = 'PAUSED',
  STOPPED = 'STOPPED',
  PARTIALLY_COMPLETED = 'P_COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  FAILED = 'FAILED',
  IN_QUEUE = 'IN_QUEUE',
  CANCELLED = 'CANCELLED',
  SCHEDULED = 'SCHEDULED',
}
